// scripts/prepare_pyodide.mjs 가 생성한다. 직접 고치지 말 것.
export const PYODIDE_VERSION = "314.0.6";
export const PYODIDE_BASE_URL = "/vendor/pyodide/314.0.6/";
